export default __webpack_public_path__ + "static/security-a2a350976b2acbfcdda3d02943f9220b.svg";